// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgCoffee = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id="Vrstva_1"
    data-name="Vrstva 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="313 191 220 220"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.cf-1 {
  stroke: #fff;
}

.cf-1,
.cf-2,
.cf-3,
.cf-4 {
  stroke-miterlimit: 10;
}

.cf-1,
.cf-4 {
  stroke-width: 0.25px;
}

.cf-5 {
  fill: #bfe6ff;
  opacity: 0.8;
}

.cf-6,
.cf-3 {
  fill: #fff;
}

.cf-7 {
  fill: #484747;
}

.cf-8 {
  fill: #f39ee5;
}

.cf-2,
.cf-3 {
  stroke: #000;
  stroke-width: 0.5px;
}

.cf-9 {
  fill: var(--mascot-accent, #ff49a4);
  opacity: 0.4;
}

.cf-4 {
  fill: none;
  stroke: #484747;
}

.cf-10 {
  fill: #936037;
}
`}</style>
    </defs>
    <path
      className="cf-6"
      d="M528.4,301.95c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.4.27-.8.53-1.2.79-.59.39-1.18.77-1.78,1.14-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-.04-.02-.09-.05-.13-.08-.01,0-.01-.01-.02-.01-.24-.17-.5-.32-.74-.5-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path
      className="cf-9"
      d="M528.4,301.95c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.4.27-.8.53-1.2.79-.59.39-1.18.77-1.78,1.14-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-.04-.02-.09-.05-.13-.08-.01,0-.01-.01-.02-.01-.24-.17-.5-.32-.74-.5-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path d="M346.36,348.32c-.59-1.9,6.83-11.18,11.97-17.47,5.14-6.26,10.66-13.16,16.23-18.55,2.28-2.22,5.6-5.24,8.71-8.01.68-.64,1.35-1.24,1.99-1.81,2.15-1.9,4.03-3.56,5.2-4.58.78-.69,1.23-1.09,1.23-1.09,0,0,1.42,12.49.72,18.04-.02.17-.04.32-.08.49-.76,5.51-2.97,12.87-7.14,17.88-.72.86-1.45,1.65-2.23,2.39-.46.43-.94.88-1.42,1.29-.45.4-.98.79-1.52,1.22-.71.56-1.43,1.09-2.16,1.63-.11.06-.22.15-.33.24-.29.21-.56.41-.86.62-1.61,1.13-3.25,2.29-4.91,3.62-.24.18-.48.37-.71.56-.28.24-.54.46-.79.68-5.33,4.63-12.85,11.9-14.79,11.21-1.96-.7-8.53-6.43-9.11-8.34Z" />
    <path d="M471.37,342.81c-.3-.2-.57-.41-.87-.61-.1-.1-.21-.18-.33-.24-.73-.54-1.45-1.08-2.16-1.64-.55-.43-1.08-.82-1.54-1.22-.48-.41-.95-.85-1.42-1.29-.78-.74-1.51-1.54-2.23-2.39-4.18-5.02-6.4-12.4-7.15-17.93-.04-.16-.06-.31-.09-.48-.7-5.56.73-18.09.73-18.09,0,0,.44.4,1.22,1.09,1.18,1.02,3.06,2.69,5.22,4.59.64.58,1.31,1.18,1.99,1.82,3.01,2.69,6.23,5.6,8.5,7.82.04-.01.07-.04.1-.07.3-.21.57-.41.87-.63,1.61-1.14,3.26-2.29,4.92-3.63.24-.18.47-.37.71-.57.27-.24.53-.45.78-.68,5.35-4.64,12.88-11.93,14.83-11.23,1.96.7,8.56,6.44,9.13,8.36.6,1.91-6.84,11.22-12,17.52-4.95,6.03-10.25,12.67-15.63,17.97l-5.59,1.52Z" />
    <path
      className="cf-6"
      d="M480.44,390.34c-.59.39-1.18.77-1.78,1.14-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-1.48-8.23-1.56-17,.18-26.04,1.2-6.21,2.58-12.31,4.17-18.22.86-3.18,1.78-6.31,2.76-9.36.03-.12.07-.24.11-.36,4.79-14.91,11.07-28.03,19.12-37.56.07-.08.14-.16.21-.24,8.37-9.82,18.64-15.77,31.12-15.82h.16c13.1,0,23.97,6.24,32.72,16.71.12.14.24.28.35.42,7.48,9.09,13.4,21.27,17.82,35.27.68,2.14,1.32,4.31,1.91,6.53,1.98,7.2,3.59,14.79,4.84,22.63,1.45,9.1,1.22,17.91-.35,26.16Z"
    />
    <path
      className="cf-2"
      d="M473.73,335.02c-9.04,18.50-28.51,31.29-51.06,31.29s-41.16-12.24-50.44-30.07c9.83-30.55,25.90-53.62,50.61-53.62s41.25,21.90,50.89,52.40Z"
    />
    <path
      className="cf-1"
      d="M459.36,290.60s.07-.01.07-.01c-4.87,15.33-15.32,25.33-18.62,36.33-4.41,14.64-5.74,29.70-6.99,31.06-2.51,2.70-17.53,2.70-20.87,0-1.67-1.36-1.16-15.65-6.16-28.65-5.67-14.74-6.48-16.94-13.77-28.24.01-.03.03-.07.07-.10-4.41-6.72-10.61-19.21-10.61-30.57,0-25.40,18.14-46,40.50-46s40.50,20.60,40.50,46c0,7.25-1.48,14.10-4.11,20.18Z"
    />
    <g>
      <path
        className="cf-8"
        d="M392.33,285.25c1.31-.54,2.18-1.07,2.71-2.37.53-1.30.27-2.29-.30-3.58-.57-1.29-1.96-2.48-3.16-3-1.20-.52-2.03-.70-3.31-.46-1.28.23-3.28,1.50-3.77,2.82-.48,1.32-.27,2.29.30,3.58.56,1.29,1.58,2.36,3.16,3,1.58.63,3.06.56,4.37.02Z"
      />
      <path
        className="cf-8"
        d="M453.35,285.20c-1.32-.51-2.20-1.03-2.76-2.32-.55-1.29-.31-2.29.23-3.59.54-1.30,1.91-2.52,3.10-3.06,1.19-.54,2.01-.74,3.30-.53,1.29.21,3.31,1.43,3.82,2.74.51,1.31.31,2.29-.23,3.59-.54,1.30-1.53,2.39-3.10,3.06-1.57.66-3.05.62-4.37.11Z"
      />
    </g>
    <path
      className="cf-7"
      d="M400.01,233.40c-4.06,3.33-7.87,7.43-10.59,12.21-3.55-1.70-7.21-4.04-7.73-6.51-.96-4.55,1.01-9.31,3.89-11.25,2.88-1.94,5.45-2.03,8.82-1.16,1.65.41,3.83,3.59,5.62,6.71Z"
    />
    <path
      className="cf-7"
      d="M464.33,239.10c-.52,2.47-4.69,4.81-8.24,6.51-2.72-4.78-5.87-8.01-9.93-11.35,1.79-3.12,3.81-7.16,5.46-7.58,3.38-.87,5.94-.78,8.82,1.16,2.88,1.94,4.85,6.70,3.89,11.25Z"
    />
    <path
      className="cf-3"
      d="M397.91,264.11c.09-5.44-4.27-9.92-9.73-10-5.46-.09-9.95,4.25-10.04,9.69-.09,5.44,4.27,9.92,9.73,10,5.46.09,9.95-4.25,10.04-9.69Z"
    />
    <path d="M388.97,272.22c4.46.69,8.25-3.08,7.57-7.52-.42-2.77-2.69-5.02-5.45-5.45-4.46-.69-8.25,3.08-7.57,7.52.43,2.77,2.69,5.02,5.45,5.45Z" />
    <path
      className="cf-3"
      d="M467.10,264.11c.09-5.44-4.27-9.92-9.73-10-5.46-.09-9.95,4.25-10.04,9.69-.09,5.44,4.27,9.92,9.73,10,5.46.09,9.95-4.25,10.04-9.69Z"
    />
    <path d="M454.15,271.86c4.46.69,8.25-3.08,7.56-7.52-.43-2.77-2.69-5.02-5.45-5.44-4.46-.69-8.25,3.08-7.56,7.52.43,2.77,2.69,5.02,5.46,5.44Z" />
    <path
      className="cf-10"
      d="M517.62,288.03l-1.19,31.95h-.01c-.17.51-3.85,1.20-8.39,1.55s-8.29.23-8.53-.25h-.04s-6.04-31.42-6.04-31.42h0s0,0,0,0c.05.68,5.51.82,12.19.31,6.58-.50,11.89-1.45,12.01-2.13Z"
    />
    <path
      className="cf-10"
      d="M517.62,288h0s0,.02,0,.04c-.12.68-5.43,1.63-12.01,2.13-6.68.51-12.14.37-12.19-.31h0c-.03-.69,5.33-1.65,12-2.16s12.12-.38,12.20.30Z"
    />
    <path
      className="cf-4"
      d="M518.40,287.46l-1.32,33.36h-.01c-.18.54-4.10,1.26-8.94,1.63s-8.83.25-9.09-.25h-.04s-6.39-32.80-6.39-32.80h0s0,0,0,0c.05.71,5.87.85,12.99.30,7.01-.54,12.67-1.53,12.80-2.24Z"
    />
    <path
      className="cf-4"
      d="M518.40,287.43h0s0,.02,0,.04c-.12.71-5.79,1.71-12.80,2.24-7.12.55-12.94.41-12.99-.30h0c-.03-.72,5.68-1.73,12.79-2.28s12.92-.41,13,.30Z"
    />
    <rect
      className="cf-5"
      x={499.81}
      y={293.55}
      width={5.8}
      height={5.8}
      rx={1.97}
      ry={1.97}
      transform="translate(81.72 -107.74) rotate(13.31)"
    />
    <rect
      className="cf-5"
      x={502.08}
      y={312.62}
      width={5.8}
      height={5.8}
      rx={1.98}
      ry={1.98}
      transform="translate(-88.07 262.17) rotate(-26.86)"
    />
    <path d="M515.27,316.47c-2.97-7.75-6.11-15.43-9.25-23.11-1.48-3.62-2.97-7.23-4.41-10.86-.37-.93-.76-1.76-1.66-2.28-.70-.40-1.55-.62-2.31-.87-1.86-.62-3.73-1.19-5.57-1.85-1.52-.54-2.17,1.88-.66,2.41,1.73.61,3.49,1.15,5.23,1.73.75.25,1.94.43,2.40,1.11s.67,1.67.97,2.41c1.41,3.47,2.82,6.93,4.24,10.40,2.92,7.17,5.85,14.34,8.62,21.57.57,1.49,2.99.84,2.41-.66h0Z" />
    <rect
      className="cf-5"
      x={508.01}
      y={302.41}
      width={5.8}
      height={5.8}
      rx={2.09}
      ry={2.09}
      transform="translate(83.98 -109.39) rotate(13.31)"
    />
    <ellipse
      cx={496.78}
      cy={304.09}
      rx={4.8}
      ry={2.9}
      transform="translate(-83.91 349.53) rotate(-35.95)"
    />
  </svg>
);
export { SvgCoffee };
